import DataModels from "./DataModels";
import BackgroundTasks from "./BackgroundTasks";
import Collections from "./Collections";
import DataModelAnalytics from "./DataModelAnalytics";
import Collection from "./Collection";
import DataModelData from "./DataModelData";
import TableData from "./TableData";
import DataModelSettings from "./DataModelSettings";
import Service from "./Service";
import Endpoints from "./Endpoints";
import Services from "./Services";
import * as selectors from "./dataModels.selectors";
import * as useQueryActions from "./dataModels.actions";
import * as slice from "./dataModels.reducers";
import CollectionCard from "./CollectionCard";
import ApiDocs from "./ApiDocs";
import Secrets from "./Secrets";
import DataModelDeploymentsTrack from "./DataModelDeploymentsTrack";

export const {
  name,
  reducer,
  actions: {
    setSelectedProperty,
    setSelectedDataModelId,
    setSelectedDataModel,
    setSelectedBackgroundTask,
    setDataModelsFilters,
    setCollectionsFilters,
    setTableDataFilters,
    setFormattedFilters,
    setSelectedCollectionId,
    setCollection,
    setSelectedRecords,
    setSelectedEndpoint,
    setReactFlowStore,
    setSelectedServiceId,
    setSelectedNode,
    setShouldShowLoadingPage,
    setNodeDetails,
    setSelectedService,
    updateTableData,
    setIsFetching,
    resetImageSelector,
    setDeployStatus,
    setPipelineStatus,
    resetReferenceCollectionsData,
    setSelectedSecretKey,
    setServiceFilters,
    setAutoMapper,
    resetDataModelDetails,
    setNewService,
    setEndpointFilters,
    setDataModelResources,
    setAreResourcesPending,
    setDataModelWithPendingResources
  },
} = slice;

export const {
  fetchCollections,
  fetchDataModels,
  createDataModel,
  deleteDataModel,
  createCollection,
  deleteCollection,
  updateCollection,
  fetchBackgroundTasks,
  createBackgroundTask,
  deleteBackgroundTask,
  fetchCollection,
  fetchDataModel,
  updateDataModel,
  updateBackgroundTask,
  fetchAllRecordsFromTable,
  addNewRecordIntoTable,
  updateRecordIntoTable,
  createEndpoint,
  deleteEndpoint,
  fetchEndpoints,
  updateEndpoint,
  createService,
  updateService,
  fetchService,
  fetchServices,
  deleteService,
  fetchDataModelRegions,
  fetchSwaggerData,
  deployBEApp,
  validateSqlExpression,
  validateSmtpConnection,
  fetchPipelineStatus,
  fetchReferenceCollectionsData,
  fetchENVSecrets,
  deleteSecret,
  createSecret,
  updateSecretKey,
  fetchDataModelDeploymentsTrack,
  executeQuery,
  importCSV,
  importCollection,
  fetchFilteredDataModels,
  createCollectionFromTemplates
} = useQueryActions;

export const {
  selectCollections,
  selectCollection,
  selectSelectedProperty,
  selectDataModels,
  selectSelectedDataModelId,
  selectSelectedDataModel,
  selectBackgroundTasks,
  selectTotalDataModels,
  selectSelectedBackgroundTask,
  selectDataModelsFilters,
  selectCollectionsFilters,
  selectTableDataFilters,
  selectFormattedFilters,
  selectBackgroundTaskFilters,
  selectEndpointFilters,
  selectSelectedDataTable,
  selectSelectedRecords,
  selectTableData,
  selectSelectedCollectionId,
  selectTotalBackgroundTasks,
  selectTotalCollections,
  selectEndpoints,
  selectServices,
  selectTotalEndpoints,
  selectTotalServices,
  selectService,
  selectSelectedEndpoint,
  selectSelectedServiceId,
  selectSelectedNode,
  selectShouldShowLoadingPage,
  selectSelectedNodeDetails,
  selectSwaggerData,
  selectDataModelRegions,
  selectDeployStatus,
  selectPipelineStatus,
  selectReferenceCollectionsData,
  selectRecentDeployedEndpointInfo,
  selectSelectedSecrets,
  selectSelectedSecretKey,
  selectServiceFilters,
  selectDataModelDeploymentsTrack,
  selectAutoMapper,
  selectNewService,
  selectSelectedDataModelResources,
  selectAreResourcesPending,
  selectDataModelWithPendingResources,
} = selectors;

export {
  BackgroundTasks,
  Collection,
  Collections,
  DataModelAnalytics,
  DataModels,
  DataModelSettings,
  DataModelData,
  TableData,
  CollectionCard,
  Service,
  Endpoints,
  Services,
  ApiDocs,
  Secrets,
  DataModelDeploymentsTrack,
};
